module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/redux-act-async/~/babel-runtime/core-js/object/define-property.js
// module id = 1998
// module chunks = 0